import type { TemplateConfig } from './constants.extra'

/**
 * THIS FILE IS AUTO-GENERATED. DO NOT EDIT.
 * Generated from /networks/oasis/config.json
 */
const TEMPLATE_CONFIG = {
  EIP155: false,
  SUPPORTED_VERSIONS: ['1.3.0', '1.4.1'],
  SAFE_UTILS_SUPPORTED: false,
  EXTRA_FOOTER_LINKS: [
    { label: 'Oasis Network', link: 'https://oasis.net' },
    { label: 'Terms', link: 'https://oasis.net/terms-of-use' },
  ],
  LOGO_DIMENSIONS: {
    HEADER: {
      H: '30px',
    },
    WELCOME: {
      W: 'auto',
      H: '55px',
    },
  },
  ALLOWANCE_MODULE_OVERRIDE: {
    '0.1.0': '0xE46FE78DBfCa5E835667Ba9dCd3F3315E7623F8a',
    '0.1.1': '0xE46FE78DBfCa5E835667Ba9dCd3F3315E7623F8a',
  },
  IS_LICENSED: false,
} as TemplateConfig
export default TEMPLATE_CONFIG
